import { take, select } from 'redux-saga/effects';
import { getOrderTiming } from '../../../../../util/orderTiming';

// Observe state after reduction, not action names or object identity. Keep
// observing every action so an intervening change-and-back also invalidates.
export default function* watchCheckoutContext(
  expected,
  checkoutContext,
  readOnlyIssuedStatus = false
) {
  while (true) {
    yield take('*');
    const state = yield select((value) => value);
    if (
      checkoutContext(state) !== expected ||
      (!readOnlyIssuedStatus && getOrderTiming(state).requiresConfirmation)
    )
      return true;
  }
}
